export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref9261.d2e42e6c.jpg";